"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_datepicker_1 = __importDefault(require("react-datepicker"));
const react_input_mask_1 = __importDefault(require("react-input-mask"));
require("react-datepicker/dist/react-datepicker.css");
const JkcDate = (props) => {
    const { name, settings, onChangeEvent, onBlurEvent, onFocusEvent } = props;
    const datepickerRef = (0, react_1.useRef)(null);
    const [isOpen, setOpen] = (0, react_1.useState)(false);
    let labelStyle = {
        marginBottom: "0px",
        position: settings.isNormalLabel ? "relative" : "absolute",
        paddingLeft: settings.isNormalLabel ? "0px" : "7px",
        zIndex: 999,
        fontSize: "16px",
        fontWeight: "bold",
    };
    let inputStyle = {
        width: "100%",
        padding: settings.isNormalLabel ? "0px 5px 0px 5px" : "10px 0px 0px 5px",
        fontSize: "15px",
        border: "1px solid #D3D3D3",
        outline: "none",
    };
    let iconStyle = {
        position: "absolute",
        right: "14px",
        lineHeight: settings.inputStyle.height,
    };
    let fieldStyle = {
        position: "relative",
        width: "100%",
        display: settings.fieldTypes == "Grid" ? "flex" : "block",
        borderTop: settings.fieldTypes == "Grid" ? "1px solid #dddddd" : "none",
        borderBottom: settings.fieldTypes == "Grid" ? "1px solid #dddddd" : "none",
        marginTop: "-1px",
    };
    if (settings.fieldTypes == "Grid") {
        fieldStyle.alignItems = "center";
    }
    let fieldLablStyle = {
        width: settings.fieldTypes == "Grid" ? "30%" : "100%",
        padding: settings.fieldTypes == "Grid" ? "10px 10px" : "0px",
    };
    let fieldInputStyle = {
        width: settings.fieldTypes == "Grid" ? "70%" : "100%",
        padding: settings.fieldTypes == "Grid" ? "10px 10px" : "0px",
        borderLeft: settings.fieldTypes == "Grid" ? "1px solid #dddddd" : "none",
        position: "relative",
    };
    if (settings.fieldTypes == "Grid") {
        fieldLablStyle.textAlign = "right";
        iconStyle.right = "23px";
    }
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ style: fieldStyle, className: "component-area-cn" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ style: fieldLablStyle }, { children: !settings.hideLabel ? ((0, jsx_runtime_1.jsx)("label", Object.assign({ style: Object.assign(Object.assign({}, labelStyle), settings.labelStyle), htmlFor: name }, { children: settings.label ? settings.label : "Label" }))) : null })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ style: fieldInputStyle }, { children: [(0, jsx_runtime_1.jsx)(react_datepicker_1.default, { id: settings.id ? settings.id : name, name: name, monthsShown: 1, tabIndex: settings.tabIndex ? settings.tabIndex : undefined, placeholderText: settings.placeholder ? settings.placeholder : "MM/DD/YYYY", disabled: settings.disabled ? settings.disabled : false, readOnly: settings.readOnly ? settings.readOnly : false, selected: settings.value, dateFormat: settings.dateFormat ? settings.dateFormat : "MM/dd/yyyy", minDate: settings.minDate ? settings.minDate : undefined, maxDate: settings.maxDate ? settings.maxDate : undefined, preventOpenOnFocus: true, customInput: (0, jsx_runtime_1.jsx)(react_input_mask_1.default, { alwaysShowMask: true, mask: "99/99/9999", maskChar: "#", id: settings.id ? settings.id : name, name: name, style: Object.assign(Object.assign({}, inputStyle), settings.inputStyle) }), className: settings === null || settings === void 0 ? void 0 : settings.className, onChange: onChangeEvent, onBlur: onBlurEvent, onFocus: onFocusEvent, ref: datepickerRef, popperClassName: settings.popperClassName ? settings.popperClassName : undefined, popperPlacement: settings.popperPlacement ? settings.popperPlacement : undefined, showTimeSelect: settings.showTimeSelect ? settings.showTimeSelect : false, showTimeSelectOnly: settings.showTimeSelectOnly ? settings.showTimeSelectOnly : false, timeIntervals: settings.timeIntervals ? settings.timeIntervals : undefined, timeCaption: settings.timeCaption ? settings.timeCaption : undefined, showMonthDropdown: true, showYearDropdown: true, onCalendarClose: () => { setOpen(false); }, onCalendarOpen: () => {
                            const datepickerElement = datepickerRef.current;
                            !isOpen && datepickerElement.setOpen(false);
                        }, dropdownMode: "select" }), (0, jsx_runtime_1.jsx)("i", { className: "fas fa-calendar", style: Object.assign(Object.assign(Object.assign({}, iconStyle), { bottom: settings.fieldTypes == "Grid" ? "10px" : "0px" }), settings.iconStyle), onClick: () => {
                            const datepickerElement = datepickerRef.current;
                            datepickerElement.setOpen(true);
                            setOpen(true);
                        } })] }))] })));
};
exports.default = JkcDate;
